import { Report } from './models/report.model';

export function getProviderErrorMessage(report: Report): string {
    return !report.Provider.Id  ? 'Por favor, selecione um provedor válido' : '';
}

export function getNameErrorMessage(report: Report): string {
    return !report.Name ? 'Por favor, informe o nome do relatório' : '';
}

export function getNameMenuErrorMessage(report: Report): string {
  return !report.MenuSystem ? 'Por favor, informe o nome do menu' : '';
}

export function getNameSubMenuErrorMessage(report: Report): string {
  return !report.SubMenuSystem ? 'Por favor, informe o nome do submenu' : '';
}

export function validateForm(report): string {
    let message = '';

    message += getProviderErrorMessage(report);

    if (!message) {
      message += getNameErrorMessage(report);
      if (report.SystemReport) {
        if (!message) {
          message += getNameMenuErrorMessage(report);
          if (!message) {
            message += getNameSubMenuErrorMessage(report);
          }
        }
      }
    }

    return message;
}
